module.exports = __webpack_public_path__ + "img/lu.b59ee6e0.svg";